import axios from 'axios';

type Payload = {
    operatorId: number;
    newRole: number;
};

type Opts = {
    auth: {
        token: string;
    };
};

const ADMIN_URL = process.env.REACT_APP_ADMIN_USERS_URL;

const updateOperatorRole = async (
    payload: Payload,
    opts: Opts
): Promise<boolean | null> => {
    try {
        const { operatorId, newRole } = payload;
        const response = await axios.patch(
            `${ADMIN_URL}/operators/${operatorId}/role`,
            { newRole },
            {
                headers: {
                    Authorization: `Bearer ${opts.auth.token}`,
                },
            }
        );
        return response.data;
    } catch (err) {
        console.log('Error updating operator role:', err);
        return null;
    }
};

export { updateOperatorRole };
